import React, {Component} from "react"
import PropTypes from "prop-types"

export default class NumericField extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    getInitialValue: PropTypes.func,
    getError: PropTypes.func
  }

  constructor(props, context) {
    super(props)
    this.state = {
      value: context.getInitialValue
        ? context.getInitialValue(this.props.name)
        : null
    }
  }

  onChange(event) {
    let newText = ""
    let numbers = "0123456789"

    for (var i = 0; i < event.target.value.length; i++) {
      if (numbers.indexOf(event.target.value[i]) > -1) {
        newText = newText + event.target.value[i]
      }
    }
    event.target.value = newText

    this.setState({
      value: event.target.value
    })
    if (this.context.onChange) {
      this.context.onChange(this.props.name, event.target.value)
    }
    if (this.props.onChange) {
      this.props.onChange(event)
    }
  }

  render() {
    return (
      <label htmlFor={this.props.name}>
        <span>{this.props.label}</span>
        <input
          type={this.props.type}
          name={this.props.name}
          onChange={this.onChange.bind(this)}
          value={this.props.value || this.state.value || ""}
        />
        {this.renderError()}
      </label>
    )
  }

  renderError() {
    if (!this.context.getError) {
      return null
    }

    let error = this.context.getError(this.props.name)
    if (error) {
      return <span className="error">{error}</span>
    }
  }
}

NumericField.propTypes = {
  value: PropTypes.number
}



// WEBPACK FOOTER //
// ./src/components/fields/NumericField.js